"use strict";
/**
 * OpenSearch User Search Types
 *
 * Minimal contract interface for the `users` OpenSearch index family. There is no
 * dedicated user search-document builder in lambda-utilities (users are indexed by the
 * reindex script + identity decoration), so this interface captures exactly the fields
 * the `users` index template maps: identity_id, screen_name, photo, reputation_score, bio.
 *
 * It exists so `USER_FIELDS` (in `user-definition.ts`) can be typed
 * `as const satisfies Record<string, keyof UserSearchDocument>`, keeping the field-name
 * constants and the contract structurally unable to drift — the same approach used for
 * `PatternSearchDocument`/`PATTERN_FIELDS`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
